import { type FC, memo } from 'react';
// Import Helpers
import { getSafeHttpUrl } from 'services/Helpers';

interface Props {
    messageBody?: string;
    imageUrl?: string;
}

/**
 * Preview of a push notification body. Rendered with `renderToString`, so the stored
 * values are escaped instead of being concatenated into HTML.
 */
const PushPreview: FC<Props> = ({ messageBody = '', imageUrl }) => {
    const safeImageUrl = getSafeHttpUrl(imageUrl);

    return (
        <div>
            {messageBody}
            <div style={{ padding: '12px', fontFamily: 'sans-serif' }}>
                {safeImageUrl && (
                    <div style={{ marginBottom: '12px' }}>
                        <img
                            src={safeImageUrl}
                            alt=""
                            style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

PushPreview.displayName = 'PushPreview';

export default memo(PushPreview);
